export const ROLES = {
  SRM_ADMIN: { id: 'SRM_ADMIN', name: 'Administrator' },
  SRM_EMPLOYEE: { id: 'SRM_EMPLOYEE', name: 'Region Manager' },
  MANAGER: { id: 'MANAGER', name: 'Manager' },
  SUPERVISOR: { id: 'SUPERVISOR', name: 'Supervisor' },
  RESPONDER: { id: 'RESPONDER', name: 'Responder' },
  GUARD: { id: 'GUARD', name: 'Guard' },
  SECURITY_COMPANY_MANAGER: {
    id: 'SECURITY_COMPANY_MANAGER',
    name: 'Account Holder',
  },
  CLIENT: { id: 'CLIENT', name: 'Customer' },
  CUSTOMER: { id: 'CUSTOMER', name: 'Customer (SR)' },
  OPERATOR: { id: 'OPERATOR', name: 'Operator' }, // added this role to show same icon on map for user having supervisor cum responder or manager cum responder role
  CLEANER: { id: 'CLEANER', name: 'Cleaner' },
  // TEAMLEAD: { id: 'TEAMLEAD', name: 'Team Lead' },
  DRIVER: { id: 'DRIVER', name: 'Driver' },
  MAINTAINER: { id: 'MAINTAINER', name: 'Maintainer' },
};
/**
 * Roles that belong to a company.  Used to filter out customers and admin roles.
 * @type {(string)[]} ids used for the roles.
 */
export const COMPANY_ROLES = [
  //standard users
  ROLES.MAINTAINER.id,
  ROLES.CLEANER.id,
  ROLES.GUARD.id,
  //email users
  ROLES.DRIVER.id,
  ROLES.RESPONDER.id,
  //portal users
  ROLES.SUPERVISOR.id,
  ROLES.MANAGER.id,
  ROLES.SECURITY_COMPANY_MANAGER.id,
];

export const formatRoleNames = role => {
  const roleName = [];
  role.forEach((roleString, index) => {
    if (Object.hasOwnProperty.call(ROLES, roleString)) {
      roleName.push(ROLES[roleString].name);
      if (role.length === index + 1) {
        roleName.push(' ');
      } else {
        roleName.push(',');
        roleName.push(' ');
      }
    } else {
      roleName.push('-');
    }
  });
  return roleName;
};

export const USER_STATUS = {
  AVAILABLE: { id: 'AVAILABLE', name: 'Available' },
  NOT_LOGGED_IN: { id: 'NOT_LOGGED_IN', name: 'Logged Out' },
  ON_BREAK: { id: 'ON_BREAK', name: 'On Break' },
  ON_TASK: { id: 'ON_TASK', name: 'On Task' },
  ON_INTERRUPTABLE_TASK: {
    id: 'ON_INTERRUPTABLE_TASK',
    name: 'On Interupptable Task',
  },
  UNAVAILABLE: { id: 'UNAVAILABLE', name: 'Unavailable' },
};

export const MULTI_ROLE_SEPARATOR = ', ';

export const MANAGEMENT_ROLES_OPTIONS = [ROLES.MANAGER, ROLES.SUPERVISOR];

export const ALL_ROLES_OPTIONS = [
  ROLES.SRM_ADMIN,
  ROLES.SRM_EMPLOYEE,
  ROLES.MANAGER,
  ROLES.SUPERVISOR,
  ROLES.RESPONDER,
  ROLES.GUARD,
  ROLES.SECURITY_COMPANY_MANAGER,
  ROLES.CLIENT,
  ROLES.CUSTOMER,
  ROLES.DRIVER,
  ROLES.MAINTAINER,
];

export const PORTAL_ACCESS_ROLES = [
  ROLES.MANAGER.id,
  ROLES.SECURITY_COMPANY_MANAGER.id,
  ROLES.SRM_ADMIN.id,
  ROLES.SRM_EMPLOYEE.id,
  ROLES.SUPERVISOR.id,
];

export const DISTRESS_VIEW_ROLES = [
  ROLES.SECURITY_COMPANY_MANAGER.id,
  ROLES.MANAGER.id,
  ROLES.SUPERVISOR.id,
  ROLES.SRM_EMPLOYEE.id,
];

export const OPERATION_VIEW_ROLES = [
  ROLES.SECURITY_COMPANY_MANAGER.id,
  ROLES.MANAGER.id,
  ROLES.SUPERVISOR.id,
];

export const MANAGER_VIEW_ROLES = [
  ROLES.SECURITY_COMPANY_MANAGER.id,
  ROLES.MANAGER.id,
];

export const ACCOUNT_VIEW_ROLES = [ROLES.SECURITY_COMPANY_MANAGER.id];

export const REGION_VIEW_ROLES = [ROLES.SRM_EMPLOYEE.id, ROLES.SRM_ADMIN.id];

export const PERSONNEL_ROLES = [
  ROLES.CLEANER.id,
  ROLES.DRIVER.id,
  ROLES.GUARD.id,
  ROLES.MANAGER.id,
  ROLES.RESPONDER.id,
  ROLES.SUPERVISOR.id,
  ROLES.MAINTAINER.id,
];
